import {z} from 'zod';

import {translations} from 'presentation/translations-new';
import {IDENTIFIER_LENGTH, clearLoginMask, validateCPF} from 'presentation/utils';

const {invalidCPF, invalidEmail} = translations['pt-br'].publicFlow.errors;

export const formSchema = z.object({
	login: z
		.string()
		.trim()
		.min(1)
		.transform(val => val.replace(/\s/g, ''))
		.transform(val => (val.includes('@') ? val : clearLoginMask(val)))
		.refine(
			val => {
				if (val.includes('@')) {
					return z.string().email().safeParse(val).success;
				}
				if (val.length === IDENTIFIER_LENGTH.cpf) {
					return validateCPF(val);
				}
				return true;
			},
			val => ({message: val.includes('@') ? invalidEmail : invalidCPF}),
		),
	password: z
		.string()
		.trim()
		.min(1)
		.transform(val => val.replace(/\s/g, '')),
});

export type IFormData = z.infer<typeof formSchema>;
